export const InfinityDate = '9999-01-01';
export const CookiesKeys = {
    IgmRegID: 'igmRegID',
    IgmContent: 'igmContent',
    IgmAuth: 'igmAuth',
    NzwRegId: 'nzwRegId',
    NzwToken: 'nzwToken',
    NzwLid: 'nzwLid',
    UserLastUpdateDate: 'nxt_userLastUpdateDate',
    UserDataExpiration: 'nxt_AccountDataExpirationCookie',
    RegistrationWalls: 'IsActCr',
    CookiesPrivacy: 'igmck',
    Auth0AccountId: "auth0_sub",
    IgmEpref: 'igm_epref',
    AuthLoginData: 'nxt_alng',
    LastVisit: 'nxt_last_visit',
    Auth0Jwt: 'auth0_jwt',
    Auth0DeviceIdForSession: 'auth0DeviceIdForSession',
    SubscriptionPurchased: 'subscriptionPurchased',
    UserData: "Connext_UserData"
};
export const DefaultResponseErrorMessage = 'Sorry, there\'s a server problem or a problem with the network. ';
export const StorageKeyPrefixes = {
    Cookie: 'sub_',
    LSDublicateCookie: 'nxt_',
};
export const StorageKeyPostfixes = {
    Device: "_device",
};
export const StorageKeys = {
    AccessToken: "Connext_AccessToken",
    ConnextAuthType: "connext_auth_type",
    ConnextCheckDomainWrite: "nxt_ckck_dmn_wrt",
    ConnextDomain: "nxt_dmn",
    ConnextMessagingData: "nxt_msg_dt", // local storage
    ConnextMessagingDataExpire: "nxt_msg_expr", // cookie
    ConnextPaywallFired: "connext_paywallFired",
    ConnextRootDomain: "nxt_rt_dmn",
    ConnextTimeRepeatableActions: "nxtact",
    ConnextUpdateArticleCount: "nxt_upd_ac",
    ConnextUserData: "connext_user_data",
    ConnextUserProfile: "connext_user_profile",
    ConnextUserId: "anonDeviceId",
    ConnextUserLastUpdateDate: "connext_userLastUpdateDate",
    ConnextViewStructure: "nxt", //  Cookie name
    ViewsAutoResetLastDate: "nxt_vwsrld",
    Configuration: "Connext_Configuration",
    Conversations: {
        Current: "Connext_CurrentConversations", // array of current conversations (1 for each MeterLevel)
        Previous: "Connext_PreviousConversations", // array of previous conversations (1 for each MeterLevel)...not really used, but requested in case the client would want to look up data on previous conversations.
        All: "Connext_AllConversations"
    },
    CurrentConversationsActions: "Connext_AllConversationsActions",
    CurrentConversation: "CurrentConversation",
    CurrentConversationActions: "CurrentConversationActions",
    CustomZip: "CustomZip",
    LastPublishDate: "Connext_LastPublishDate",
    RepeatablesInConv: 'repeatablesInConv',
    RepeatablesInArticle: 'repeatablesInArticle',
    ViewedArticles: "Connext_ViewedArticles", // holds array of viewed articles.
    GlobalLocation: "GlobalLocation",
    AllowUseCode: 'nxt_allowUseCode',
    NeedHidePinTemplate: 'NeedHidePinTemplate',
    PinAttempts: 'PinAttempts',
    ArticleCost: 'ArticleCost',
    StartLoadPlugin: 'StartLoadPlugin',
    UniqueArticles: 'uniqueArticles',
    PublishSettings: 'ConneXtpS',
    ForceConfigDownload: "nxt_cfg_force",
    EngagementRate: "Engagement_Rate",
    IsMakeReRunOnLogin: "IsMakeReRunOnLogin",
    DebugPanel: {
        CdpProfile: "CDP_profile",
        ZipCode: "dbZipCode",
        ConfigurationIsCustom: "Connext_Configuration_isCustom",
        ConfigCode: "Connext_Configuration_ConfigCode",
        SiteCode: "Connext_Configuration_SiteCode",
        LogLevel: "Connext_Log_Level",
        DebugPanelOpenState: 'Connext_debug_panel_open_state'
    },
    DebugMode: "nxt_debug",
    AdblockLastDetect: 'connext_adblock_last_detect',
    DebugTraceExpirationDate: 'nxt_debug_trace_expiration_date',
    IsIncognitoBrowsing: "nxt_is_incognito",
    AnonDeviceIdRegenStats: "anonDeviceIdRegenStats",
    AutoQA: "nxt_autoQA",
    DisqusToken: 'nxtDisqus',
    DisqusDemos: 'nxtDemos',
    AbTest: 'nxt_ab_test',
    VisitedView: 'visitedView',
    Loader: {
        ResoursesUrls: 'nxt_ldr_rsrc_rls'
    },
    BrowserSessionId: 'nxt_browser_sessionid',
    ConnextUserSessionStorage: 'nxt_UserSessionStorage',
    SetRegWallCookie: 'setRegWallCookie',
    isCurrentArticleNew: 'Connext_isCurrentArticleNew',
    loginWithRedirectAttempted: 'loginWithRedirectAttempted',
    ConnextFAA: 'Connext_FAA',
    ConnextFAL: 'Connext_FreeArticlesList',
    ConnextSK: 'Connext_SettingKey',
    LoginWithRedirectFailed: 'nxt_LgnWthRdrctFld',
    Qualifiers: 'qualifiers',
    EmailPreference: "igm_epref",
    NewsletterSource: 'nxt_nl_source',
    NewsletterReader: 'nxt_nl_reader',
    NewsletterNW: 'nxt_NW',
    LoginCount: "LoginCount",
    PageViewCount: 'nxt_page_view_count',
};
export const UrlKeys = {
    Encryptedeventid: 'encryptedeventid',
    ReturnUrl: 'returnurl',
    FacebookNewsToken: 'fb_news_token'
};
export const ConvoArticleCountObj = {
    ArticleCount: "ac", //  Article count on conversation level
    DeviceArticleCount: "ac_d", //  Device article count on conversation level
    StartDate: "s" //  Conversation start date
};
export const MeteredArticleCountObj = {
    ActiveConvoId: "_acnv", //  Active conversation Id
    ActiveConvoCode: "_acnv" //  Active conversation Code
};
export const TimeRepeatableActionsCS = {
    RepeatAfter: 'rpt', //  Repeat after
    Count: 'rtpc' //  Repeated times (count)
};
export const NewsletterStorageKey = {
    EncryptedEmail: "igm_eui",
    EmailPreference: "igm_epref",
    NewsletterSource: 'nxt_nl_source',
    NewsletterReader: 'nxt_nl_reader',
    NewsletterNW: 'nxt_NW'
};
